function importAll( r ){
    r.keys().forEach( r );
}

import api from './assets/common/js/api.js';
window.api = api;

// FANCYBOX
import { Fancybox } from "@fancyapps/ui";
import { Carousel } from "@fancyapps/ui/dist/carousel/carousel.esm.js";
import "@fancyapps/ui/dist/fancybox/fancybox.css";
import "@fancyapps/ui/dist/carousel/carousel.css";
window.Carousel = Carousel;

Fancybox.defaults.Toolbar = {
    display : {
        left : [ "infobar" ] ,
        middle : [
            "zoomIn" ,
            "zoomOut" ,
            "toggle1to1" ,
            // "rotateCCW" ,
            // "rotateCW" ,
            // "flipX" ,
            // "flipY" ,
        ] ,
        right : [
            // "slideshow" ,
            // "thumbs" ,
            "download",
            "close"
        ] ,
    } ,
};

window.Fancybox = Fancybox;


export * from './assets/site/js/common.js';
export * from './assets/site/js/site.js';
export * from './assets/site/js/filter.js';
export * from './assets/site/js/basket.js';

export * from './assets/site/css/settings.css';
export * from './assets/site/css/main.css';
export * from './assets/site/css/site.css';
export * from './assets/site/css/mobile.css';
export * from './assets/site/css/mobile.window.css';
export * from './assets/site/css/icons.css';
export * from './assets/site/css/filter.css';
export * from './assets/site/css/sort.css';
export * from './assets/site/css/cookie.css';

export * from './views/site/pages/main/main.css';
export * from './views/site/pages/main/main.js';

export * from './views/site/pages/checkout/main.css';
export * from './views/site/pages/checkout/main.js';

export * from './views/site/pages/detail/main.css';
export * from './views/site/pages/detail/main.js';

export * from './views/site/pages/storelist/main.css';
export * from './views/site/pages/storelist/main.js';

export * from './views/site/pages/store/main.css';
export * from './views/site/pages/store/main.js';

export * from './views/site/pages/catalog/main.css';
export * from './views/site/pages/catalog/main.js';

export * from './views/site/lk/main.css';

export * from './views/site/lk/personal/main.css';
export * from './views/site/lk/personal/main.js';

export * from './views/site/pages/basket/main.js';
export * from './views/site/pages/basket/main.css';

export * from './views/site/pages/page/main.css';

export * from './views/site/pages/search/main.css';

export * from './views/site/blocks/measure/style.css';
export * from './views/site/blocks/care/style.css';

importAll( require.context( './assets/common/js' , true , /\.js$/ ) );
importAll( require.context( './assets/site/img' , true , /\.(png|jpg|jpeg|svg|webp)$/ ) );


